import { render, staticRenderFns } from "./retentionDialog.vue?vue&type=template&id=66f12b2a&scoped=true"
import script from "./retentionDialog.vue?vue&type=script&lang=js"
export * from "./retentionDialog.vue?vue&type=script&lang=js"
import style0 from "./retentionDialog.vue?vue&type=style&index=0&id=66f12b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f12b2a",
  null
  
)

export default component.exports